import Image from "next/image";
import Link from "next/link";

import { PostPageNameEnum } from "@/types/posts";

interface IPostHeroSection {
    data: any;
    pageName?: PostPageNameEnum
    page?: number;
}
function PostHeroSection({ data, pageName, page }: IPostHeroSection) {
    const path = `/${pageName}/${data?._sys.filename}${page ? `?page=${page}` : ""}`;
    return (
        <Link
            href={path}>
            <div className="posts-container article-container">
                <div className="posts-container-link">
                    <h3>
                        {data.title}
                    </h3>
                    {
                        data?.heroImage
                        && <Image
                            src={data?.heroImage}
                            alt="Image"
                            className="image-section"
                            loading="lazy"
                            width={400}
                            height={400}
                        />
                    }
                </div>
            </div>
        </Link>
    );
}

export default PostHeroSection;
